var balanceShadowVariantInputs = function(evt){
  if (window.BOLD && BOLD.common && BOLD.common.cartDoctor) {
    // Bold:POv2 - new functionality to ensure quantity changes can be made in one ajax call (much faster than individual line updates)
    input = this;
    BID = 0;
    qty = input.value;
    key = input.dataset.id;
    cart = BOLD.common.cartDoctor.rawCart;
    for (i = 0; i < cart.items.length; i++) {
      if (key == cart.items[i].key &&
          cart.items[i].properties &&
          cart.items[i].properties._boldBuilderId &&
          cart.items[i].properties._boldVariantIds &&
          !cart.items[i].properties._boldVariantQtys) {
        //We have a base item with no complex quantity conditions, add the BID to the array
        BID = cart.items[i].properties._boldBuilderId;
      }
    }
    //BID should be set, match the quantity of priced options
    if (BID) {
      for (i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties &&
            cart.items[i].properties._boldBuilderId == BID &&
            !cart.items[i].properties._boldVariantIds) {
          dependents = document.querySelectorAll('input[id="updates_'+ cart.items[i].key +'"]');
          dependents.forEach(function(dep){
            dep.value = qty;
            dep.setAttribute("value", qty);
          });
        }
      }
    }
    //END Bold:POv2 - custom code block
    //END Custom input updater
  }
}

document.addEventListener("DOMContentLoaded", function(e) {
  let inputs = document.querySelectorAll('input[name="updates[]"]');
  inputs.forEach(function(i){
    i.addEventListener("change", balanceShadowVariantInputs);
  });
});

